import { render, staticRenderFns } from "./DeliveryLocation.vue?vue&type=template&id=f086dfdc&scoped=true&"
import script from "./DeliveryLocation.vue?vue&type=script&lang=js&"
export * from "./DeliveryLocation.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLocation.vue?vue&type=style&index=0&id=f086dfdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f086dfdc",
  null
  
)

export default component.exports